<template>
  <div class="headerWrap">
    <div class="iconBox">
      <!-- <img src="@/assets/images/icon1.png" /> -->
      <!-- <img src="@/assets/images/icon2.png" /> -->
      <img src="@/assets/images/icon.png" />
      <div class="changeIcon">
        <i
          :class="[
            isCollapse ? 'iconfont icon-caidanyou' : 'iconfont icon-caidanzuo',
          ]"
          @click="changeMenuType"
        ></i>
      </div>
    </div>
    <div class="listBox">
      <div class="topBox">
        <div class="rowBox" v-if="planList?.length">
          <el-tag effect="plain" size="mini"> 今日计划 </el-tag>
          <ul>
            <li
              v-for="v in planList"
              :key="v.name"
              @click="
                $router.push(
                  v.name == '巡检计划' ? '/patrolPlan' : '/maintainPlan'
                )
              "
            >
              <p>{{ v.name }}</p>
              <span>{{ v.value }}</span>
            </li>
          </ul>
        </div>
        <div class="rowBox">
          <el-tag effect="plain" size="mini" v-if="warningList.length">
            今日报警
          </el-tag>
          <ul>
            <li
              @click="$router.push('/alarmManagement')"
              v-for="(v, i) in warningList"
              :key="v.name"
            >
              <p>{{ v.name }}</p>
              <span :style="{ color: colorList[i] }">{{ v.value }}</span>
            </li>
          </ul>
        </div>
        <div class="rowBox">
          <el-tag effect="plain" size="mini" v-if="orderList.length">
            今日工单
          </el-tag>
          <ul>
            <li
              @click="$router.push('/worksheets')"
              v-for="(v, i) in orderList"
              :key="v.name"
            >
              <p>{{ v.name }}</p>
              <span :style="{ color: colorList[i] }">{{ v.value }}</span>
            </li>
          </ul>
        </div>
        <div class="userBox">
          <el-popover placement="bottom" trigger="hover">
            <div style="text-align: center">
              <div style="text-align: center">
                <el-link @click="personalDialog = true">个人中心</el-link>
              </div>
              <el-link @click="confirm">退出登录</el-link>
            </div>

            <p slot="reference">{{ userName }}</p>
          </el-popover>
        </div>
      </div>
      <div class="bottomBox">
        <el-tabs
          v-model="nowRouter"
          type="card"
          :closable="closable"
          @tab-remove="removeTab"
          @tab-click="clickTabs"
          size="mini"
        >
          <el-tab-pane
            :key="item.path"
            v-for="item in tabsList"
            :label="item.title"
            :name="item.path"
          >
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <PersonalDialog v-if="personalDialog" />
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import PersonalDialog from "@/components/gerenzhongxin/PersonalDialog";
export default {
  components: { PersonalDialog },
  data() {
    return {
      date: dateFtt("yyyy-MM-dd", new Date()),
      weekDate: "",
      personalDialog: false,
      nowRouter: "",
      tabsList: [],
      planList: [],
      warningList: [
        { name: "高危", value: null, key: "CRITICAL" },
        { name: "危险", value: null, key: "MAJOR" },
        { name: "警告", value: null, key: "MINOR" },
      ],
      orderList: [
        { name: "紧急", value: null, key: "HIGH" },
        { name: "重要", value: null, key: "MEDIUM" },
        { name: "一般", value: null, key: "LOW" },
        { name: "安全隐患", value: null, key: "SAFETY_HAZARD" },
      ],
      colorList: ["#FF4E3E", "#FF9400", "#D2C085", "#FA541C"],
      projectId: "",
      userName: "",
      isCollapse: false,
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        this.nowRouter = val.path;
        this.tabsList = JSON.parse(window.sessionStorage.getItem("routeTabs"));
      },
      deep: true,
    },
  },
  computed: {
    closable: {
      // getter
      get: function () {
        return this.tabsList.length > 1;
      },
      // setter
      set: function (newValue) {
        return this.tabsList.length > 1;
      },
    },
  },
  methods: {
    changeMenuType() {
      this.isCollapse = !this.isCollapse;
      window.sessionStorage.setItem("SidebarStatus", this.isCollapse);
      this.$emit("getIconType", this.isCollapse);
      this.$bus.$emit("getChangeMenuType", this.isCollapse);
    },
    clickTabs() {
      this.$router.push(this.nowRouter);
    },
    removeTab(targetName) {
      let tabs = this.tabsList;
      this.tabsList = this.tabsList.filter((v) => {
        return v.path != targetName;
      });
      this.$store.commit("SET_RouteTabs", this.tabsList);

      let activeName = this.nowRouter;
      if (activeName === targetName) {
        tabs.forEach((tab, index, arr) => {
          if (tab.path === targetName) {
            let nextTab = arr[index + 1] || arr[index - 1];
            if (nextTab) {
              activeName = nextTab.path;
            }
          }
        });
      }
      this.nowRouter = activeName;
      this.clickTabs();
      if (this.tabsList.length === 1) {
        this.closable = false;
      }
    },
    confirm() {
      this.$confirm("确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("logout");
          this.$store.commit("SET_ROUTE", []);
        })
        .catch(() => {});
    },
    async getAlarmData() {
      let res = await api.getSAlarmAnalysis({
        type: "DAY",
        data: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        this.warningList.map((v) => {
          v.value = res.data.data.alarmLevelAnalysis.find((item) => {
            return item.name == v.key;
          }).value;
        });
      }
    },
    async getOrderData() {
      let res = await api.logisticsWOANALOverview({
        type: "DAY",
        date: dateFtt("yyyy-MM-dd", new Date()),
      });
      if (res && res.data.code == 200) {
        this.orderList.map((v) => {
          v.value = res.data.data.charts.find((item) => {
            return item.name == v.key;
          }).value;
        });
      }
    },
    async getPlanData() {
      let res = await api.headerGetPlanTolData({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        key: "UserPlans",
        dateType: "DAY",
      });
      if (res && res.data.code == 200) {
        this.planList = res.data.data;
      }
    },
    async getRefreshToken() {
      //先判过期时间2小时，如果超过用refreshtoken刷新token,
      const diffTime =
        new Date().getTime() - window.sessionStorage.getItem("expirationTime");
      if (diffTime > 2 * 60 * 60 * 1000) {
        const refreshToken = window.sessionStorage.getItem("refreshToken");
        let res = await api.refreshTokenPost({ refreshToken });
        console.log("刷新token===res==========", res);
        if (res.status == 200 && res?.data) {
          const { token, refreshToken } = res.data;
          window.sessionStorage.setItem("refreshToken", refreshToken);
          window.sessionStorage.setItem("token", token);
          window.sessionStorage.setItem("expirationTime", new Date().getTime());
        }
      }
    },
  },
  created() {
    let userData = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.isCollapse =
      window.sessionStorage.getItem("SidebarStatus") === "true" ? true : false;
    this.$emit("getIconType", this.isCollapse);
    this.nowRouter = JSON.parse(window.sessionStorage.getItem("nowRouter"));
    this.tabsList = JSON.parse(window.sessionStorage.getItem("routeTabs"));
    this.projectId = userData.projects[0].projectId;
    this.userName =
      userData.identity == "projectAdmin"
        ? "系统管理员"
        : userData.identity == "operation"
        ? "巨基运营"
        : userData.name;
    this.getAlarmData();
    this.getOrderData();
    this.getPlanData();
    const timer = setInterval(() => {
      setTimeout(() => {
        this.getAlarmData();
        this.getOrderData();
        this.getPlanData();
        this.getRefreshToken();
      }, 0); //利用定时器清除setInterval的每次叠加
    }, 1000 * 60);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(timer);
    });
  },
};
</script>

<style scoped lang="scss">
.headerWrap {
  width: 100%;
  height: 100%;
  @include setFlexBetween;

  .iconBox {
    width: 13%;
    height: 100%;
    @include setFlexCenter;
    position: relative;

    // img {
    //   width: 80%;
    //   // width: 40%;
    //   margin: auto;
    // }
    .changeIcon {
      position: absolute;
      right: 10px;
      bottom: 5px;
      color: #28cccb;
      font-size: 20px;
      cursor: pointer;

      i {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }

  .listBox {
    width: 87%;
    height: 100%;
    @include setFlexColumn;
    justify-content: space-between;

    .topBox {
      width: 100%;
      height: 50%;
      @include setFlexBetween;
      justify-content: flex-end;

      ::v-deep .el-tag--plain {
        background-color: transparent;
        border: 1px solid #1c909b;
      }

      .rowBox {
        display: flex;
        height: 100%;
        align-items: center;
        margin-right: 20px;

        ul {
          display: flex;
          color: #fff;
          margin-left: 10px;

          li {
            display: flex;
            margin-right: 10px;
            cursor: pointer;

            p {
              margin-right: 5px;
            }

            span {
              color: #28cccb;
            }
          }
        }
      }

      .rowBox:first-child {
        li:nth-child(odd) {
          color: #b4b8c2;

          span {
            color: #b4b8c2;
          }
        }
      }

      .userBox {
        color: #fff;
        margin-right: 20px;
      }
    }

    .bottomBox {
      width: 100%;
      // height: 50%;
      margin-bottom: 2px;

      ::v-deep .el-tabs--card {
        // height: 100%;
      }

      ::v-deep .el-tabs--card > .el-tabs__header {
        // height: 100%;
        margin: 0;
        border: none;

        // .el-tabs__nav-wrap {
        //   height: 100%;
        //   .el-tabs__nav-prev {
        //     height: 100%;
        //     @include setFlexCenter;
        //   }
        //   .el-tabs__nav-next {
        //     height: 100%;
        //     @include setFlexCenter;
        //   }
        //   .el-tabs__nav-scroll {
        //     height: 100%;
        //   }
        // }
        .el-tabs__nav {
          border: none;

          .el-tabs__item {
            border: none;
            background: #edf2f2;
            border-radius: 6px 6px 0px 0px;
            margin-right: 3px;
          }
        }

        .el-tabs__item.is-active {
          background: #28cccb;
          color: #fff;
        }
      }

      ::v-deep .el-icon-arrow-left,
      ::v-deep .el-icon-arrow-right {
        color: #fff;
      }
    }
  }
}
</style>
